import classNames from 'classnames'
import type { ReactNode } from 'react'
import styles from './FsaBadge.module.scss'

export interface FsaBadgeProps {
  theme?: 'dark' | 'light' | 'purple' | 'black'
  alignment?: 'horizontal' | 'vertical'
}

export function FsaBadge({ theme = 'dark', alignment = 'horizontal' }: FsaBadgeProps): ReactNode {
  const fsaBadgeStyle = classNames(styles.FsaBadge__icon, {
    [styles.FsaBadge__iconThemeBlack]: theme === 'black',
    [styles.FsaBadge__iconThemeDark]: theme === 'dark',
    [styles.FsaBadge__iconThemeLight]: theme === 'light',
    [styles.FsaBadge__iconThemePurple]: theme === 'purple',
  })

  const fsaBadgeTextStyle = classNames(styles.FsaBadge__text, {
    [styles.FsaBadge__textThemeBlack]: theme === 'black',
    [styles.FsaBadge__textThemeDark]: theme === 'dark',
    [styles.FsaBadge__textThemeLight]: theme === 'light',
    [styles.FsaBadge__textThemePurple]: theme === 'purple',
  })

  return (
    <div className={alignment === 'horizontal' ? styles.FsaBadge : styles.FsaBadge__vertical}>
      <svg className={fsaBadgeStyle} xmlns="http://www.w3.org/2000/svg">
        <path
          className={styles.FsaBadge__tick}
          transform="translate(7, 3)"
          d="M11 19l-8-7-2 2 10 10L32 3l-2-2-19 18z"
        />
        <path
          className={styles.FsaBadge__circle}
          d="M33.8 14.8A15.3 15.3 0 0119 34.4c-8.4 0-15.3-6.9-15.3-15.3A15.3 15.3 0 0130.1 8.5l2.7-2.7A19 19 0 000 19c0 10.5 8.6 19.1 19.1 19.1a19.2 19.2 0 0017.7-26.4l-3 3z"
        />
      </svg>
      <div className={fsaBadgeTextStyle}>
        <span className={styles.FsaBadge__types}>FSA &amp; HSA</span>
        <br />
        <span className={styles.FsaBadge__status}>Eligible</span>
      </div>
    </div>
  )
}
